<template>
  <div>
    <div class="detail-top">
        <backindex :msg="detailMsg"></backindex>
    </div>
    <list type="more" :typeid="typeid" keyword=""></list>
  </div>

</template>
<script>
import list from "@/components/index/list";
import backindex from "@/components/common/backindex";
export default {
  name: "more",
  components: {
    list,
    backindex,
  },
  data:function(){
    return {
      detailMsg:this.$route.query.title,
      typeid:this.$route.query.tid,
    }
  },
  mounted:function(){
    this.typeid;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/index/more.vue